/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Media_Source_Hls_ManifestInputs */



/**
* | output |
* | --- |
* | "HLS Manifest" |
*
* @param {New_Project_Media_Source_Hls_ManifestInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_media_source_hls_manifest = /** @type {((inputs?: New_Project_Media_Source_Hls_ManifestInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Media_Source_Hls_ManifestInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Manifeste HLS")
	if (locale === "de") return /** @type {LocalizedString} */ ("HLS-Manifest")
	if (locale === "it") return /** @type {LocalizedString} */ ("Manifesto HLS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Манифест HLS")
	if (locale === "es") return /** @type {LocalizedString} */ ("Manifiesto HLS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("HLS清单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("HLSマニフェスト")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एचएलएस मैनिफेस्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Manifesto HLS")
	return /** @type {LocalizedString} */ ("HLS Manifest")
});